import { render, staticRenderFns } from "./fertilizer.vue?vue&type=template&id=ccca6e1a&scoped=true&"
import script from "./fertilizer.vue?vue&type=script&lang=js&"
export * from "./fertilizer.vue?vue&type=script&lang=js&"
import style0 from "./fertilizer.vue?vue&type=style&index=0&id=ccca6e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccca6e1a",
  null
  
)

export default component.exports